import { store } from '@/decorators/store';
import { AssignmentWindowConfig } from '@/entities/AssignmentWindowConfig';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'AssignmentWindowConfigStore' })
export class AssignmentWindowConfigStore extends AbstractEntityStore<AssignmentWindowConfig> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'windowMinutes';
  protected entityValueKey = 'windowMinutes';
}
